export default __webpack_public_path__ + "static/media/usdt.c1d58766.png";